import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()((theme) => ({
  box: {
    padding: 8,
    background: theme.secondary.s5,
    borderRadius: theme.borderRadius.md,
    width: '100%',
  },
  boxTitle: {
    ...dFlex('start', 'start'),
    flexDirection: 'column',
    gap: 8,
  },
}));

export default useStyles;
